import React from 'react';
import { IconProps } from '.';

const SvgColoredDocument = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill='#AAB1B5' d='m20.648 6.95-5.4-5.4a1.2 1.2 0 0 0-1.697 1.697V8.65h5.4a1.2 1.2 0 0 0 1.697-1.697Z' />
      <path
        fill='#E2E5E6'
        d='M14.4 1.2h-9A2.4 2.4 0 0 0 3 3.6v16.8a2.4 2.4 0 0 0 2.4 2.4h13.2a2.4 2.4 0 0 0 2.4-2.4V7.8h-5.4c-.6 0-1.2-.6-1.2-1.2V1.2Z'
      />
      <path
        fill='#878F91'
        fillRule='evenodd'
        d='M6.4 8.4a.8.8 0 0 1 .8-.8h3.6a.8.8 0 0 1 0 1.6H7.2a.8.8 0 0 1-.8-.8ZM6.4 12a.8.8 0 0 1 .8-.8h9.6a.8.8 0 0 1 0 1.6H7.2a.8.8 0 0 1-.8-.8ZM6.4 15.6a.8.8 0 0 1 .8-.8h9.6a.8.8 0 0 1 0 1.6H7.2a.8.8 0 0 1-.8-.8Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgColoredDocument;
